import * as React from 'react'
import { useEffect, useState } from 'react'
import style from './style.module.css'
import animateStyle from './animate.module.css'
import { CSSTransition } from 'react-transition-group'
import { bridge, defaultConfig } from './bridge'
import successImg from './images/success.png'
import warningImg from './images/warning.png'
import errorImg from './images/error.png'
import loadingImg from './images/loading.png'
import classNames from 'classnames'

export interface ToastConfig {
  type?: 'success' | 'warning' | 'error' | 'loading'
  //'success','warning','error','loading'
  icon?: string
  tip?: string
  duration?: number
  closeAuto?: boolean
  delay?: boolean
  delayTime?: number
  closeMask?: boolean
  zIndex?: number
}

function typeContent(type: string,tip?: string) {
  const typeJson = {
    'success': ['操作成功', successImg],
    'warning': ['警示操作', warningImg],
    'error': ['操作错误', errorImg],
    'loading': ['加载中', loadingImg]
  };

  return {
    tip: tip ? tip : typeJson[type][0],
    icon: typeJson[type][1]
  }
}

function renderContent(config: ToastConfig) {
  // 设置类型时，通过类型渲染已确定的icon与文字，后续会补充文档
  const typeArr = ['success', 'warning', 'error', 'loading']
  if (config.type) {
    const typeError = typeArr.indexOf(config.type) === -1
    if (typeError) throw 'self-defining type is not allowed, please check the document'
    if(config.tip) {
      return typeContent(config.type,config.tip)
    } else {
      return typeContent(config.type)
    }
  }

  // 用户自定义icon与文字
  if (!config.icon || !config.tip) {
    throw 'please check your config,if type is undefined, tip&icon is needed'
  }

  return {
    tip: config.tip,
    icon: config.icon
  }
}

export function Toast() {
  const [config, setConfig] = useState<ToastConfig>(defaultConfig)
  const [show, setShow] = useState<boolean>(false)
  const [showContent, setShowContent] = useState<boolean>(true)

  useEffect(() => {
    let timer : any
    let delayTimer : any

    // 用户设置配置参数
    bridge.setConfig = (config) => {
      clearTimeout(timer)
      setShow(true)
      setConfig(config)

      if(config.delay && config.delayTime) {
        clearTimeout(delayTimer)
        setShowContent(false)
        delayTimer = setTimeout(() => setShowContent(true), config.delayTime)
      }

      if (config.closeAuto && config.duration) {
        timer = setTimeout(() => setShow(false), config.delayTime && config.delay ? config.duration + config.delayTime : config.duration)
      }
    }

    // 用户可手动关闭toast
    bridge.closeToast = () => {
      clearTimeout(timer)
      setShow(false)
    }

    return () => {
      clearTimeout(timer)
      clearTimeout(delayTimer)
    }
  }, [])

  const content = renderContent(config)

  return (
    <CSSTransition
      in={show}
      timeout={300}
      classNames={{
        enter: animateStyle['toast-enter'],
        enterActive: animateStyle['toast-active-enter'],
        exit: animateStyle['toast-exit'],
        exitActive: animateStyle['toast-active-exit'],
      }}
      unmountOnExit
    >
      <div
        className={style['toast-box']}
        id='weike-ui-toast'
        style={{ zIndex: config.zIndex }}
      >
        {!config.closeMask && <div className={style['mask']}></div>}
        {
          showContent &&
          <div className={style['toast-content']}>
            <div>{ content.tip }</div>
            <img
              src={ content.icon }
              className={
                classNames(
                  style['icon'],
                  config.type &&
                  config.type === 'loading' ?
                    animateStyle.loading :
                    ''
                )
              }
            />
          </div>
        }
      </div>
    </CSSTransition>
  )
}



// WEBPACK FOOTER //
// ../src/popup-layer/toast/index.tsx